import Vue from 'vue';
import { gsap } from 'gsap';
import _ from 'lodash';
import { format, addDays, isTomorrow, isToday, isWeekend, isThisWeek, isThisMonth, isSameMonth, addMonths, isSameWeek, addWeeks, isFuture, eachDayOfInterval, isWithinInterval, startOfToday, startOfTomorrow} from 'date-fns';
import { nl } from 'date-fns/locale'

Vue.component('agenda-filter-component', {
    props: {
        initialOptions: {
            type: Array,
        },
        allItems: {
            type: Array
        },
    },
    data() {
        return {
            // Types
            activeTypes: [],
            options: [],

            // Days
            activeDate: '',
            selectedDate: '',

            // Events
            allEvents: [],
            events: [],
            groupedEvents: [],
            showedEvents: [],

            // First amount of visible days
            numberEvents: 8, // How many grouped events (days) you want to show

            // Break events
            numberBreak: 4, // (this is also the place where the break will come for the popular events block) Normally it's the half of the beginning numberEvents.

            // Counting (load more)
            countNumberEvents: 16, // How many days you want to add when clicking on the load more button.

            // dates
            today: new Date(),

            // search
            search: '',

            isFiltered: false
        }
    },

    mounted() {
        var menu = document.querySelector('.agenda-filter-desktop')
        var menuPosition = menu.offsetTop - menu.scrollTop + menu.clientTop;

        window.addEventListener('scroll', ()  => {
            if (window.pageYOffset + 106 >= menuPosition) {
                menu.classList.add('fixed');
            } else {
                menu.classList.remove('fixed');
            }
        });

        // All Types
        let options = [];
        this.options = [...options, ...this.initialOptions];

        // Events
        this.allEvents = this.allItems.filter((event) => {
            // check if events are all in future or are ongoing (if eventEndDate is in future)
            const eventEndDateFuture = event.eventEndDate !== null ? (isToday(new Date(event.eventEndDate)) || isFuture(new Date(event.eventEndDate))) : false;
            if (eventEndDateFuture) {
                event.allDays = eachDayOfInterval({ start: new Date(event.eventStartDate),  end: new Date(event.eventEndDate) });
            }

            return isToday(new Date(event.eventStartDate)) || isFuture(new Date(event.eventStartDate)) || eventEndDateFuture;
        });

        this.events = this.allEvents;

        this.groupedEvents = _.groupBy(this.allEvents, "eventDay");     

        this.addOverlappigEvents();
        
        // only display groups if its today or future
        var result = {};
        Object.keys(this.groupedEvents).filter(key => {
            return isToday(new Date(key)) || isFuture(new Date(key))
        }).forEach((key) => {
            result[key] = this.groupedEvents[key];
        })

        this.groupedEvents = result
    },

    watch: {
        activeTypes: function(val) {
            if (val) {
                this.activeTypeChange();
                this.activeDateChange();
                this.isFiltered = true;
            }
        },

        activeDate: function(val) {
                this.activeDateChange();
                this.isFiltered = true;
        },

        search: function(val) {
            this.isFiltered = true;
            if (val) {
                this.searchFilter();
            } else {
                // if the search input in empty go back to the latest filtering
                this.activeDateChange();
            }
        },

    },

    filters: {
        datePrettyformatter: function(val) {
            return format(new Date(val), "EEEE dd MMMM", { locale: nl } )
        }
    },

    methods: {
        toggleMobileFilter(event) {
            const element = event.currentTarget;
            const collapse = document.querySelector('.filter-overlay');

            if (collapse.classList.contains('open')) {
                element.classList.remove('collapsed');
                collapse.classList.remove('open')
                gsap.to(collapse, { height: 0, opacity: 0, display: 'none' });
                return;
            }

            element.classList.add('collapsed');
            collapse.classList.add('open');
            gsap.to(collapse, { display: 'block', height: '100%', opacity: 1});
        },

        tempToggle(event) {
            const element = event.currentTarget;
            const parent = element.parentNode;

            const collapse = parent.querySelector('.filter-overlay__filter-item-options');

            if (collapse.classList.contains('open')) {
                collapse.classList.remove('open')
                gsap.to(collapse, { height: 0 });
                return;
            }

            collapse.classList.add('open');
            gsap.to(collapse, { height: 'auto' });
        },

        tempToggleTwo(filter) {
            const element = event.currentTarget;
            const parent = element.parentNode;

            const collapse = parent.querySelector('.filter__filter-item-options');

            if (collapse.classList.contains('open')) {
                element.classList.remove('collapsed');
                collapse.classList.remove('open')
                gsap.to(collapse, { height: 0, opacity: 0 });

                return;
            }

            /* When user opens a second dropdown, close the other dropdown so only 1 dropdown is visible */
            /* ==== Beginning ==== */
            var otherFilter = document.querySelector('.filter__filter-current-dates');
            if(filter === 'dates') {
                otherFilter = document.querySelector('.filter__filter-current-types');
            }

            const otherFilterParent = otherFilter.parentNode;
            const collapseOtherFilter = otherFilterParent.querySelector('.filter__filter-item-options');

            if (collapseOtherFilter.classList.contains('open')) {
                collapseOtherFilter.classList.remove('open');
                otherFilter.classList.remove('collapsed')
                gsap.to(collapseOtherFilter, { height: 0, opacity: 0 });
            }
            /* ==== End ===== */

            element.classList.add('collapsed');
            collapse.classList.add('open');
            gsap.to(collapse, { height: 'auto', opacity: 1});
        },

        selectAll() {
            this.activeTypes = [];
            this.events = this.allEvents;
            this.groupedEvents = _.groupBy(this.events, "eventDay");
            this.addOverlappigEvents();
        },

        toggleType(type) {
            if (this.activeTypes.indexOf(type.label) > -1) {
                this.activeTypes.splice(this.activeTypes.indexOf(type.label), 1);
                return;
            }

            this.activeTypes.push(type.label);
            
        },

        isActiveType(type) {
            return this.activeTypes.indexOf(type.label) > -1;
        },

        activeTypeChange() {
            this.groupedEvents = [];
            if (this.activeTypes.length > 0) {
                this.events = this.allEvents.filter((element, index) => {
                    return this.activeTypes.includes(element.eventType.label)
                });
                this.groupEvents();
                return;
            }

            this.events = this.allEvents;
            this.groupEvents();
            
        },

        selectAllDays() {
            this.activeDate = '';
            this.selectedDate = event.currentTarget.dataset.label;
            this.activeTypeChange();
        },

        toggleDate(date) {
            this.selectedDate = event.currentTarget.dataset.label;
            this.activeDate = date;
        },

        isActiveDate(date) {
            return this.activeDate.indexOf(date) > -1;
        },

        activeDateChange(event) {

            this.activeTypeChange();

            // Check if filter option is set to TODAY, filter events that are only today
            if (this.activeDate == 'today') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag vandaag is of indien er overlappende dagen zijn een van deze dagen vandaag is. 
                this.events = this.events.filter((element, index) => {
                    
                    if(element.allDays) {

                        function checkArray(x) {
                            return isToday(x);
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isToday(new Date(element.eventStartDate));
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met de dag van vandaag. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isToday(new Date(key))
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result

                return;
            }

            // Check if filter option is set to TOMORROW, filter events that are only tomorrow
            if (this.activeDate == 'tomorrow') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag morgen is of indien er overlappende dagen zijn een van deze dagen morgen is. 
                this.events = this.events.filter((element, index) => {
                    if(element.allDays) {
                        function checkArray(x) {
                            return isTomorrow(x);
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isTomorrow(new Date(element.eventStartDate));
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met de dag van morgen. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isTomorrow(new Date(key))
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result

                return;
            }
            
            // Check if filter option is set to WEEKEND, filter events that are only this weekend
            if (this.activeDate == 'weekend') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag dit weekend is of indien er overlappende dagen zijn een van deze dagen dit weekend is. 
                this.events = this.events.filter((element, index) => {
                    if(element.allDays) {
                        function checkArray(x) {
                            return isWeekend(x)  && isThisWeek(x, { weekStartsOn: 1 });
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isWeekend(new Date(element.eventStartDate)) && isThisWeek(new Date(element.eventStartDate), { weekStartsOn: 1 });
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met dit weekend. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isWeekend(new Date(key)) && isThisWeek(new Date(key), { weekStartsOn: 1 })
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result

                return;
            }

            // Check if filter option is set to THISWEEK, filter events that are only this week
            if (this.activeDate == 'thisweek') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag deze week is of indien er overlappende dagen zijn een van deze dagen deze week is. 
                this.events = this.events.filter((element, index) => {
                    if(element.allDays) {
                        function checkArray(x) {
                            return isThisWeek(x, { weekStartsOn: 1 });
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isThisWeek(new Date(element.eventStartDate), { weekStartsOn: 1 });
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met deze week. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isThisWeek(new Date(key), { weekStartsOn: 1 })
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result

                return;
            }

            // Check if filter option is set to NEXTWEEK, filter events that are only next week
            if (this.activeDate == 'nextweek') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag volgende week is of indien er overlappende dagen zijn een van deze dagen volgende week is. 
                this.events = this.events.filter((element, index) => {
                    if(element.allDays) {
                        function checkArray(x) {
                            return isSameWeek(addWeeks(new Date(), 1), new Date(x), { weekStartsOn: 1 });
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isSameWeek(addWeeks(this.today, 1), new Date(element.eventStartDate), {weekStartsOn: 1})
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met volgende week. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isSameWeek(addWeeks(this.today, 1), new Date(key), { weekStartsOn: 1 })
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result

                return;
            }

            // Check if filter option is set to THISMONTH, filter events that are only this month
            if (this.activeDate == 'thismonth') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag deze maand is of indien er overlappende dagen zijn een van deze dagen deze maand is. 
                this.events = this.events.filter((element, index) => {
                    if(element.allDays) {
                        function checkArray(x) {
                            return isThisMonth(x);
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isThisMonth(new Date(element.eventStartDate));
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met volgende week. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isThisMonth(new Date(key))
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result;

                return;
            }

            // Check if filter option is set to NEXTMONTH, filter events that are only next month
            if (this.activeDate == 'nextmonth') {

                // Stap 1: filter events zodat je enkel events krijgt waarbij startdag volgende is of indien er overlappende dagen zijn een van deze dagen volgende maand is. 
                this.events = this.events.filter((element, index) => {
                    if(element.allDays) {
                        function checkArray(x) {
                            return isSameMonth(addMonths(new Date(), 1), x);
                        }
                        return element.allDays.some(checkArray);
                    }
                    return isSameMonth(addMonths(this.today, 1), new Date(element.eventStartDate))
                });
                this.groupEvents();

                // Stap 2: Nu halen we enkel die ene group uit waarbij de key overeen komt met volgende week. 
                var result = {};
                Object.keys(this.groupedEvents).filter(key => {
                    return isSameMonth(addMonths(this.today, 1), new Date(key))
                }).forEach((key) => {
                    result[key] = this.groupedEvents[key];
                })

                this.groupedEvents = result;

                return;
            }

            var result = {};
            Object.keys(this.groupedEvents).filter(key => {
                return isToday(new Date(key)) || isFuture(new Date(key))
            }).forEach((key) => {
                result[key] = this.groupedEvents[key];
            })

            this.groupedEvents = result
        },

        searchFilter() {
            this.activeDateChange();

            this.groupedEvents = [];
            this.events = this.events.filter(post => {
                return post.title.toLowerCase().includes(this.search.toLowerCase())
            })
            this.groupEvents();

            var result = {};
            Object.keys(this.groupedEvents).filter(key => {
                return isToday(new Date(key)) || isFuture(new Date(key))
            }).forEach((key) => {
                result[key] = this.groupedEvents[key];
            })

            this.groupedEvents = result
            
            return;
        },

        groupEvents() {
            this.groupedEvents = _.groupBy(this.events, "eventDay");
            this.numberEvents = this.countNumberEvents * 2;
            this.addOverlappigEvents();
        },

        nextEvents() {
            if (this.numberEvents < Object.keys(this.groupedEvents).length) {
                this.numberEvents += this.countNumberEvents;
            }
        },

        addOverlappigEvents() {
            this.events.map(element => {
                if(element.allDays ) {
                    element.allDays.forEach(day => {
                        const formattedDay = format(new Date(day), "yyyy/LL/dd", {
                            locale: nl
                          })

                        if(!(formattedDay in this.groupedEvents) ) {
                            const newDayKey = {[formattedDay]: null}
                            this.groupedEvents = {...this.groupedEvents, ...newDayKey}
                        }
                    });
                }
            });

            var orderedDates = {};
            Object.keys(this.groupedEvents).sort((a, b) => {
                return new Date(a) - new Date(b);
            }).forEach((key) => {
                orderedDates[key] = this.groupedEvents[key];
            })
            this.groupedEvents = orderedDates;
        },

        dayHasOverlappingEvents(key) {
            const overlappingEvents = this.events.filter(element => {
                if(element.allDays ) {
                    return isWithinInterval( new Date(key), { start: new Date(element.eventDay), end: new Date(element.eventEndDay) } ) && key !== element.eventDay
                }
            });

            return overlappingEvents;
        },

    },

    beforeDestroy() {

    }
});
